export default "__VITE_ASSET__Crz4W07L__"